import Vue from 'vue';
import { api } from "../../services/Api.js";
import { modalService } from '../../services/ModalService.js';
import i18n from "../../language.js";

export async function delete_absence({ state,dispatch }, payload ){

  
    // adding token
    payload.token=state.appSettings.token

    // get active school
    var school = state.user_schools.find(school => school.active === 1);
    

    var proceed=true;
    await modalService.createModal(i18n.t('language.report_fit_sure')).then(
    ()=>{ /* ok lets delete */},
    ()=>{ proceed=false;})

    if(!proceed){
      return;
    }

    
    // make api call
    return api
    .post(school,"delete_absence.php",payload)
    .then( () => { 
      
      // just reload because we dont want to track and set nested properties 
      dispatch('get_absences', payload )
      /*
      var childrenArray = state.absences[payload.store_key];
      // loop through list with children
      childrenArray.forEach(child => {
        
        let childIndex = state.absences[payload.store_key].indexOf(child);
        // find in child absence list
        var absence=child.absences.find(absence => absence.id === payload.id);
        if(absence){
          let absenceIndex = child.absences.indexOf(absence);
          commit('DELETE_ABSENCE', {key:payload.store_key ,childIndex:childIndex,absenceIndex:absenceIndex});
          
        }
      });
      */
      // just reload?

      
      //return result;
      
    })
    .catch( error => {
      Vue.$toaster.toast("store: delete_absence: "+error);
      return error;
    })
    
   
    
  }